module.exports = __webpack_public_path__ + "static/media/de_preview.137c2111.jpg";